import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { SEO } from '../components/SEO';
import { getApiBase } from '../lib/apiBase';


const API_URL = getApiBase();

export const NewsletterUnsubscribe = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    fetch(`${API_URL}/api/newsletter/unsubscribe/${token}`)
      .then(r => { if (r.ok) setStatus('success'); else setStatus('error'); })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-4" style={{ fontFamily: 'IBM Plex Sans,sans-serif' }}>
      <SEO title="Unsubscribe | Durable Designs" path="/engineering/newsletter/unsubscribe" />
      <div className="text-center max-w-md" data-testid="newsletter-unsub-page">
        {status === 'loading' && <Loader2 className="w-10 h-10 text-emerald-600 animate-spin mx-auto mb-4" />}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>Unsubscribed</h1>
            <p className="text-sm text-gray-500 mb-6">You have been removed from the mailing list and will no longer receive article notifications.</p>
            <Link to="/engineering/knowledge" className="inline-flex items-center gap-2 border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 text-sm font-medium tracking-wide transition-colors" data-testid="unsub-back-link">
              Back to Knowledge
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>Unsubscribe Failed</h1>
            <p className="text-sm text-gray-500 mb-6">This link is invalid or you have already been unsubscribed.</p>
            <Link to="/engineering/knowledge" className="inline-flex items-center gap-2 border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 text-sm font-medium tracking-wide transition-colors">
              Back to Knowledge
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default NewsletterUnsubscribe;
